import { render, staticRenderFns } from "./BDXStatusPendingManagerSaveButton.vue?vue&type=template&id=1391b495"
import script from "./BDXStatusPendingManagerSaveButton.vue?vue&type=script&lang=js"
export * from "./BDXStatusPendingManagerSaveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports